//Include Both Helper File with needed methods


import { getSupportCategories } from "../../../helpers/fakebackend_helper";

import {
  
  apiRequest,
  apiError,
 
  
} from "./reducer";

import { createAsyncThunk } from "@reduxjs/toolkit";


export const support_getCategoriesThunk = createAsyncThunk("support_getCategoriesThunk", async ({  token} ) => {
  try {
    
      const response = getSupportCategories(token);
      return response;
     
  } catch (error) {
      return error;
  }
});













